/* eslint-disable arrow-body-style */
/* global G */
import find from 'lib/sequence/component/children/find'
import seqRead from 'lib/sequence/model/api/read'
import { set } from 'lib/sequence/component/state/value'
import { disable } from 'lib/sequence/component/state/disabled'
import updateDetail from 'app/typeExtension/event/updateDetail'
import enableButtons from 'app/typeExtension/event/enableButtons'

/**
 * Read TypeExtension hook.
 *
 * Attempts to obtain a TypeExtension by its key, if it is set in the model state's ref namespace,
 * and map the view with its data. If there is no model state ref, it does nothing.
 *
 * @param {Gaia.AppModule.Spec} obj  the current module composition object
 * @returns {function(...[*]): Promise<*[]>}
 */
const readTypeExtension = obj => async (...args) => {
  const model = obj[G.MODEL]

  if (model[G.STATE][G.REF]) {
    const component = obj[G.STATE][G.ACTION][G.COMPONENT]
    const { form, detail } = find(component)
    const { dynamicData } = model[G.CHILDREN]
    const { dynamicData: dynamicForm, save } = find(detail)

    await seqRead(model)(form)

    const value = dynamicData[G.CACHE]

    await updateDetail(obj, component, null)

    set(dynamicForm, value)

    await enableButtons(obj, component, value)
    disable(save)
  }

  return args
}

export default readTypeExtension
